import { render, staticRenderFns } from "./rewardsStore.vue?vue&type=template&id=21ad2aa9&scoped=true"
import script from "./rewardsStore.vue?vue&type=script&lang=js"
export * from "./rewardsStore.vue?vue&type=script&lang=js"
import style0 from "./rewardsStore.vue?vue&type=style&index=0&id=21ad2aa9&prod&lang=css"
import style1 from "./rewardsStore.vue?vue&type=style&index=1&id=21ad2aa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad2aa9",
  null
  
)

export default component.exports